module.exports = __webpack_public_path__ + "img/bg-user.a6917dca.png";